// extracted by mini-css-extract-plugin
module.exports = {"heading":"Notification_heading__poljS","content":"Notification_content__wBSQj","underline":"Notification_underline__3GneA","notiContainer":"Notification_notiContainer__12ov-"};